<template src="./TicketComments.html"></template>

<script>
import { Mentionable } from 'vue-mention'
import { mapGetters } from 'vuex'
import { addTicketComment, getProjectMembers } from '../../services'
import { formatDate } from '../../utils/computeds'

// XAN-24 — comentarios de un ticket, con fecha. Inspirado en components/Messages/Messages.vue
// (mismo patrón visual de v-timeline). A diferencia de ese componente (que solo recuerda el email
// de la ÚLTIMA persona mencionada), aquí `mentionedUsers` acumula cada mención aplicada, así que un
// comentario puede notificar a varias personas a la vez — ver onApplyMention/addComment.
export default {
  name: 'TicketComments',
  components: { Mentionable },
  props: {
    ticketId: {
      type: String,
      required: true
    },
    comments: {
      type: Array,
      default: () => []
    },
    // Sin proyecto no hay universo de miembros válido para el autocomplete de menciones.
    projectId: {
      type: String,
      default: null
    }
  },
  data: () => ({
    message: '',
    localComments: [],
    sending: false,
    members: [],
    mentionedUsers: []
  }),
  computed: {
    ...mapGetters({ user: 'getUser' }),
    formatDate,
    getFullName () {
      return (person) => `${person.name} ${person.lastName || ''}`.trim()
    }
  },
  watch: {
    comments: {
      immediate: true,
      handler (value) {
        this.localComments = [...(value || [])]
      }
    },
    projectId: {
      immediate: true,
      handler (projectId) {
        this.loadMembers(projectId)
      }
    }
  },
  methods: {
    async loadMembers (projectId) {
      if (!projectId) {
        this.members = []
        return
      }
      try {
        const members = await getProjectMembers(projectId)
        this.members = members
          .filter((member) => member.id !== this.user.id)
          .map((member) => ({ id: member.id, value: `${member.name} ${member.lastName || ''}`.trim() }))
      } catch (err) {
        console.error('Error listing project members:', err)
        this.members = []
      }
    },
    onApplyMention (item) {
      if (!this.mentionedUsers.some((mentioned) => mentioned.id === item.id)) {
        this.mentionedUsers.push(item)
      }
    },
    async addComment () {
      if (!this.message.trim()) return
      this.sending = true
      try {
        // Solo se notifica a quien siga mencionado en el texto final: si se borró el "@Nombre"
        // insertado antes de enviar, esa persona no debe recibir el correo.
        const mentionedUserIds = this.mentionedUsers
          .filter((mentioned) => this.message.includes(`@${mentioned.value}`))
          .map((mentioned) => mentioned.id)
        const comment = await addTicketComment(this.ticketId, this.message.trim(), mentionedUserIds)
        this.localComments.push(comment)
        this.message = ''
        this.mentionedUsers = []
      } catch (err) {
        console.error('Error adding ticket comment:', err)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style lang="scss" src="./TicketComments.scss" scoped></style>
